$(document).ready(function () {
  var menuItems = $(".header__inline-menu > ul > li");

  menuItems.each(function (index) {
    var nthChild = index + 1;
    var hasMegaMenu = $(".menu-" + nthChild).length > 0;

    if (hasMegaMenu) {
      $(document).on(
        "mouseenter",
        ".header__inline-menu > ul > li:nth-child(" + nthChild + ")",
        function () {
          $(".main-menu-item .main-menu-dropdown").removeClass("show-menu closing");
          $(".menu-" + nthChild).addClass("show-menu");
          $(".header-wrapper").addClass("bg-red-hover");
        }
      );
    }
  });

  // Close with animation
  $(document).on("mouseleave", ".header-wrapper", function () {
    const $dropdowns = $(".main-menu-item .main-menu-dropdown");

    $dropdowns.each(function () {
      const $menu = $(this);
      if ($menu.hasClass("show-menu")) {
        $menu.removeClass("show-menu").addClass("closing");

        // Wait for CSS transition to finish before hiding
        setTimeout(function () {
          $menu.removeClass("closing");
        }, 300); // match CSS transition duration
      }
    });

    $(".header-wrapper").removeClass("bg-red-hover");
  });

  // Tab logic
  $(".tab-sub-menus li:first-child").addClass("active");
  $(".main-menu-dropdown .tab-content").hide();
  $(".main-menu-dropdown").each(function () {
    $(this).find(".tab-content:first").show();
  });

  $(".tab-sub-menus li").mouseenter(function () {
    var $parent = $(this).closest(".main-menu-dropdown");
    $parent.find(".tab-sub-menus li").removeClass("active");
    $parent.find(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab)?.show();
    return false;
  });
});

(function () {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".tab-button[data-tab]");
    if (!btn) return;

    e.preventDefault();

    const wrapper = btn.closest(".collection-tabs-wrapper");
    if (!wrapper) return;

    const tabId = btn.dataset.tab;

    // Remove active from ALL buttons
    wrapper
      .querySelectorAll(".tab-button[data-tab]")
      .forEach((b) => b.classList.remove("active"));

    // Hide ALL tab contents
    wrapper
      .querySelectorAll(".tab-content")
      .forEach((c) => c.classList.remove("active"));

    // Activate selected tab
    btn.classList.add("active");
    wrapper.querySelector(`#${tabId}`)?.classList.add("active");
  });

  // Default tab on load
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".collection-tabs-wrapper")
      .forEach((wrapper) => {
        const firstBtn = wrapper.querySelector(
          ".tab-button[data-tab]"
        );
        if (!firstBtn) return;

        const tabId = firstBtn.dataset.tab;
        firstBtn.classList.add("active");
        wrapper.querySelector(`#${tabId}`)?.classList.add("active");
      });
  });

  // Shopify section reload support
  document.addEventListener("shopify:section:load", function (e) {
    const wrapper = e.target.querySelector(".collection-tabs-wrapper");
    if (!wrapper) return;

    const firstBtn = wrapper.querySelector(".tab-button[data-tab]");
    if (!firstBtn) return;

    const tabId = firstBtn.dataset.tab;
    firstBtn.classList.add("active");
    wrapper.querySelector(`#${tabId}`)?.classList.add("active");
  });
})();

